// The ink diffusion field. Extracted from sumi.js when manuscript.js needed the
// same one rather than a second copy that would drift away from it; manuscript
// has since been folded into sumi (its writing lives on in handwriting.js), so
// sumi.js is once again the only caller.
//
// It renders pigment soaking into paper, and the two details that make
// that read as INK rather than as a blur are here: a gaussian core, and a
// DARKER rim at the edge of the stain. A real ink blot is darker at its
// boundary because water carries pigment outward as it evaporates and leaves it
// there. Without the rim you get an airbrush.
//
// hasContourNoise is a compile-time branch, not a uniform: tier 0 drops the
// noise entirely and should not pay for a per-fragment test to do so.
export function inkFieldChunk(hasContourNoise) {
  return `
    // Cheap value noise - bilinear-interpolated hash lattice. Good enough for
    // "the contour is irregular and different per blot", not meant to be a
    // general-purpose noise function.
    float hash21(vec2 p) {
      p = fract(p * vec2(123.34, 456.21));
      p += dot(p, p + 45.32);
      return fract(p.x * p.y);
    }
    float noise2(vec2 p) {
      vec2 i = floor(p);
      vec2 f = fract(p);
      float a = hash21(i);
      float b = hash21(i + vec2(1.0, 0.0));
      float c = hash21(i + vec2(0.0, 1.0));
      float d = hash21(i + vec2(1.0, 1.0));
      vec2 u = f * f * (3.0 - 2.0 * f);
      return mix(mix(a, b, u.x), mix(c, d, u.x), u.y);
    }

    // sd is already distance/spread (or distance/halfWidth for a stroke),
    // pre-noise. seed lets each blot get its own irregularity rather than a
    // shared, obviously-repeating pattern.
    float inkProfile(float sd, vec2 p, vec2 origin, float seed, float force) {
      ${hasContourNoise ? 'sd *= 0.82 + 0.36 * noise2(p * 3.1 + origin * 7.0 + seed);' : ''}
      float blot = exp(-sd * sd * 2.2) * force;
      // Drying rim - the detail that reads as ink instead of blur.
      float rim = smoothstep(0.55, 0.95, sd) * (1.0 - smoothstep(0.95, 1.15, sd));
      blot += rim * force * 0.45;
      return blot;
    }
  `;
}
